import * as React from 'react';

const Tent = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={22} height={22} viewBox="0 0 22 22" {...props}>
        <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.3}>
            <path
                strokeWidth={1.191671}
                d="M13.877.688 1.483 20.258a.687.687 0 0 0 .58 1.055H20.19a.687.687 0 0 0 .58-1.055L8.378.688"
            />
            <path
                strokeWidth={1.191671}
                d="m7.002 21.313 3.54-5.893a.688.688 0 0 1 1.18 0l3.534 5.892M9.752 11.688h2.75"
            />
        </g>
    </svg>
);
export default Tent;
